import {
    animate,
    group,
    query,
    stagger,
    state,
    style,
    transition,
    trigger,
} from '@angular/animations';
import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnDestroy,
    ViewEncapsulation,
} from '@angular/core';

import {
    BehaviorSubject,
    Observable,
    Subject,
} from 'rxjs';
import {
    delay,
    takeUntil,
} from 'rxjs/operators';

const TRANSITION_SPEED = 125;

const animations = [
    trigger('isExpanded', [
        transition('* <=> *', [
            query('button:enter', [
                style({ opacity: 0, marginRight: '-40px' }),
                stagger(-TRANSITION_SPEED / 2, [
                    group([
                        animate(TRANSITION_SPEED * 2,  style({ opacity: 1 })),
                        animate(`${TRANSITION_SPEED}ms ease-out`,  style({ marginRight: '10px' })),
                    ]),
                ]),
            ], { optional: true }),
            query('button:leave', [
                stagger(TRANSITION_SPEED / 4, [
                    group([
                        animate(TRANSITION_SPEED, style({ opacity: 0 })),
                        animate(`${TRANSITION_SPEED / 2}ms ease-in`, style({ marginRight: '-40px' })),
                    ]),
                ]),
            ], { optional: true }),
        ]),
    ]),
    trigger('isOpen', [
        state('open', style({
            transform: 'none',
        })),
        state('closed', style({
            transform: 'rotate(-45deg)',
        })),
        transition('open <=> closed', animate(`${TRANSITION_SPEED}ms ease-in-out`)),
    ]),
];

@Component({
    selector: 'ui-action-expander',
    templateUrl: './ui-action-expander.component.html',
    styleUrls: ['./ui-action-expander.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    animations,
})
export class UiActionExpanderComponent implements OnDestroy {
    @Input()
    public tooltipOpen?: string;

    @Input()
    public tooltipClose?: string;

    @Input()
    public disabled?: boolean;

    public get isCreateMenuExpanded() {
        return this._isCreateMenuExpanded$.value;
    }

    public set isCreateMenuExpanded(expand: boolean) {
        if (expand === this._isCreateMenuExpanded$.value) {
            return;
        }

        this._isCreateMenuExpanded$.next(expand);
    }

    public isActionExpanded$: Observable<boolean>;

    private _isCreateMenuExpanded$ = new BehaviorSubject(false);
    private _destroyed$ = new Subject();

    constructor() {
        this.isActionExpanded$ = this._isCreateMenuExpanded$
            .pipe(
                // delay for element to become focusable
                delay(50),
                takeUntil(this._destroyed$),
            );
    }

    ngOnDestroy() {
        this._isCreateMenuExpanded$.complete();
        this._destroyed$.next();
    }
}
